module.exports = __webpack_public_path__ + "static/media/pdf_icon.cc859a70.svg";